const fit = (pill) => {
  const box = pill.querySelector('.menu-drawer__menu-item-text');
  const over = box.scrollWidth - box.clientWidth;
  pill.style.setProperty('--mq', `${Math.max(over, 0)}px`);
  pill.classList.toggle('is-marquee', over > 1);
};

const ro = new ResizeObserver((entries) => entries.forEach((e) => fit(e.target.closest('.pag-drawer-pill'))));
document.querySelectorAll('.pag-drawer-pill .menu-drawer__menu-item-text').forEach((el) => {
  if (!el.firstElementChild) el.innerHTML = `<span>${el.innerHTML}</span>`;
  ro.observe(el);
});
